import { IconGraduateCap } from 'central-icons/IconGraduateCap';
import isEmpty from 'lodash/isEmpty';

import { Link, Text } from '@revelio/ui';

import styles from './card-sections.module.css';
import layoutStyles from './education-history-section.module.css';

interface EducationHistoryItem {
  title?: string;
  university_name?: string;
  start_date?: string;
  end_date?: string;
}

interface EducationHistorySectionProps {
  educationHistory: EducationHistoryItem[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

const formatDateToYear = (dateString: string) => {
  if (isEmpty(dateString)) return '';
  const [year] = dateString.split('-');
  return year;
};

export const EducationHistorySection = ({
  educationHistory,
  isExpanded,
  onToggleExpanded,
}: EducationHistorySectionProps) => {
  if (!educationHistory.length) return null;

  const sortedEducationHistory = educationHistory.sort((a, b) => {
    const aDate = String(a.start_date ?? '');
    const bDate = String(b.start_date ?? '');
    if (aDate > bDate) return -1;
    if (aDate < bDate) return 1;
    return 0;
  });

  const displayEducationHistory = isExpanded
    ? sortedEducationHistory
    : sortedEducationHistory.slice(0, 1);

  return (
    <div className={layoutStyles.section}>
      <div className={layoutStyles.sectionIcon}>
        <IconGraduateCap size={16} />
      </div>
      <div className={layoutStyles.educationList}>
        {displayEducationHistory.map((edu, idx) => {
          const isLastDisplayedEducation =
            idx === displayEducationHistory.length - 1;
          return (
            <Text key={idx} fontSize="sm">
              <Text as="span" fontSize="sm">
                {String(edu.title ?? '')}
              </Text>
              {/** biome-ignore lint/style/useConsistentCurlyBraces: migrated from develop */}
              {' @ '}
              <Text as="span" fontSize="sm">
                {String(edu.university_name ?? '')}
              </Text>{' '}
              ({formatDateToYear(String(edu.start_date ?? ''))}-
              {edu.end_date
                ? formatDateToYear(String(edu.end_date))
                : 'present'}
              )
              {isLastDisplayedEducation &&
                sortedEducationHistory.length > 1 && (
                  <>
                    {' '}
                    <Link
                      className={styles.moreLink}
                      onClick={(e) => {
                        e.stopPropagation();
                        onToggleExpanded();
                      }}
                    >
                      {isExpanded ? 'Show Less' : 'More'}
                    </Link>
                  </>
                )}
            </Text>
          );
        })}
      </div>
    </div>
  );
};
